import { render, staticRenderFns } from "./lista-buscador-listados.vue?vue&type=template&id=453ad5af&scoped=true&"
import script from "./lista-buscador-listados.vue?vue&type=script&lang=ts&"
export * from "./lista-buscador-listados.vue?vue&type=script&lang=ts&"
import style0 from "./lista-buscador-listados.vue?vue&type=style&index=0&id=453ad5af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453ad5af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VList,VListItem,VMenu,VRow,VSpacer})
